<template>
  <div id="info-sidebar" class="product-info">
    <div class="product-attribute">
      <span
        v-if="selectedSpec.IsOutOfStock !== undefined && !selectedSpec.IsOutOfStock"
        class="product-preorder"
      >
        [ {{ isPreOrder }}]
      </span>
      <span class="product-temp">[{{ productTemperature }}]</span>
    </div>
    <h1 :class="{ noEvent }" class="product-name">
      {{ itemDatas.Name }}
    </h1>
    <h5 class="product-sub-name">{{ itemDatas.SubTitle }}</h5>
    <div>
      <div v-if="!noEvent" class="product-event">
        <div v-if="itemDatas.Limit !== 0">此商品限購 {{ itemDatas.Limit }} 件</div>
        <div v-for="event in itemDatas.Events" :key="event.ID">
          <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
        </div>
        <div v-for="giftEvent in itemDatas.GiftEvents" :key="giftEvent.ID">
          <a :href="'/campaign/gift/' + giftEvent.ID">{{ giftEvent.Name }}</a>
        </div>
      </div>
    </div>
    <h3 class="product-price">
      <span
        v-if="hasCheaperPrice"
        class="origin-price"
        :class="{
          mark: hasCheaperPrice,
        }"
      >
        NT.{{ itemDatas.OriginPrice }}
      </span>
      <span
        class="sell-price"
        :class="{
          mark: hasCheaperPrice,
        }"
      >
        NT.{{ mapSellPrice }}
      </span>
    </h3>
    <h5 v-if="selectedSpec !== null && selectedSpec.PreOrder" class="product-sub-name">
      {{ itemDatas.ArrivalExplanation }}
    </h5>
    <div class="d-none d-md-block product-color-wrap">
      <div class="selected-color">顏色</div>
      <div
        class="product-color"
        v-for="color in itemDatas.Colors"
        :key="color.ID"
        :class="{
          active: color.ID === selectedData.ID,
        }"
        @click.prevent="changeImg(color.ID)"
      >
        <div class="taste-cross-line" />
        <img :src="color.PintSizePictureUrl" />
      </div>
    </div>
    <p v-if="selectedSpec.Stock < 10 && selectedSpec.Stock !== 0" class="text-danger my-2">
      即將售完
    </p>
    <div class="d-none d-md-flex product-select-container">
      <div class="size-selector">
        <p class="mb-1">尺寸</p>
        <Select :options="selectedData.Specs" :selected="selectedSpec" @changeSpec="selectSpec" />
      </div>
      <div class="count-selector">
        <p class="mb-1">數量</p>
        <div class="quantity">
          <a class="quantity-btn-minus" @click.prevent="reduceCount">–</a>
          <input :value="counter" class="quantity-text" type="text" readonly />
          <a
            class="quantity-btn-plus"
            @click.prevent="addCount({ maxCount: selectedSpec.Stock, limit: itemDatas.Limit })"
          >
            ＋
          </a>
        </div>
      </div>
    </div>
    <a
      :class="btnStyleGenerate"
      class="btn d-none d-md-block mt-3 btn-add-cart"
      @click.prevent="clickToCart(addToCart)"
    >
      {{ btnDescriptionGenerate }}
    </a>
    <div id="bottom-bar" class="d-lg-none">
      <a
        :class="btnStyle"
        class="open-dialog btn-add-cart btn"
        data-dialog="#dialog-market"
        @click.prevent="showMobileCartDialog"
      >
        {{ description }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import $ from 'jquery';

import useShopContentStore from '@global/stores/useShopContentStore';
import useSpec from '@global/composable/useSpec';

import Select from '@components/Select.vue';

const shopContentStore = useShopContentStore();
const { selectedData, itemDatas, selectedSpec, counter, btnStyleGenerate, btnDescriptionGenerate } =
  storeToRefs(shopContentStore);

const { selectSpec, changeImg, addCount, reduceCount, showMobileCartDialog, addToCart } =
  shopContentStore;

const {
  IsPreOrderFactory,
  IsMapSellPriceFactory,
  IsHasCheaperPriceFactory,
  IsProductTemperatureFactory,
  IsNoEventFactory,
  IsBtnStyleFactory,
  IsDescriptionFactory,

  clickToCart,
} = useSpec();

const isPreOrder = computed(() => IsPreOrderFactory(selectedSpec.value));
const mapSellPrice = computed(() => IsMapSellPriceFactory(itemDatas.value));
const hasCheaperPrice = computed(() => IsHasCheaperPriceFactory(itemDatas.value));
const productTemperature = computed(() => IsProductTemperatureFactory(itemDatas.value));
const noEvent = computed(() => IsNoEventFactory(itemDatas.value));
const btnStyle = computed(() => IsBtnStyleFactory(itemDatas.value));
const description = computed(() => IsDescriptionFactory(itemDatas.value));
</script>
